import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';

import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import styles from './SimpleModal.styles';

function SimpleModal({
  children,
  title,
  modalButtons,
  includeCancelButton,
  hideModal,
}) {
  const intl = useIntl();

  return (
    <EcModalCard
      title={title}
      content={children}
      footer={
        <>
          {includeCancelButton && (
            <Button
              variant="tertiary"
              text={intl.formatMessage({
                id: 'SimpleModal.cancelButton',
                defaultMessage: 'Cancel',
                description: 'Cancel button text',
              })}
              onClick={hideModal}
            />
          )}
          {modalButtons}
        </>
      }
      hideModal={hideModal}
    />
  );
}

SimpleModal.propTypes = {
  title: PropTypes.string.isRequired,
  modalButtons: PropTypes.object,
  width: PropTypes.string,
  includeCancelButton: PropTypes.bool,
  hideCloseIcon: PropTypes.bool,
};

export default injectSheet(styles)(SimpleModal);
